import { Environment } from './environment.interface';

// Staging environment configuration
export const environment: Environment = {
  production: false,
  nodeEnv: 'staging',
  myApiBaseUrl: 'https://test-myapi.inspecthoa.com/api/v1.1',
  coreyApiBaseUrl: 'https://test-myapi.inspecthoa.com/api/v1.1/report-viewer',
  enableDebugMode: true,
  logLevel: 'debug',
  portalBaseUrl: 'https://test-portal.rexera.com/app/',
  foundationEscrow: [759],
};
